module.exports = __webpack_public_path__ + "img/nr.bbc94de9.svg";